import { render } from "./EtatPlacesArrieresPage.vue?vue&type=template&id=066a9752&ts=true"
import script from "./EtatPlacesArrieresPage.vue?vue&type=script&lang=ts"
export * from "./EtatPlacesArrieresPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__